import { compose } from '@reduxjs/toolkit'

import {
  constructCopyVarigramDataErrorNotification,
  constructDeletedToTrashElementAddErrorNotification,
  constructDeleteRelatedWorkflowItemErrorNotification,
  constructEmptyPointsetCalculationNotification,
  constructOrchCalculationErrorNotification,
  constructProjectStateChangedNotification,
  constructSimpleNotification,
  constructSwapWorkflowItemsErrorNotification,
  constructVspAppliedNotification,
  convertDeleteElementEventToNotification,
  convertEntityGltfLoadErrorToNotification,
  convertFileUploadErrorToNotification,
  convertMLErrorToNotification,
  convertMlNotifyStatusToNotification,
  convertPickerProgressToNotification,
  convertPolygonUploadResultToNotification,
  convertPublishedElementToNotification,
  convertSurvey2dFileUploadErrorToNotification,
  convertVSPErrorToNotification,
} from './notificationConverters'
import { notificationsSlice } from './notificationsSlice'

export const { removeNotification } = notificationsSlice.actions
const { addNotification } = notificationsSlice.actions

export const addSwapErrorNotification = compose(
  addNotification,
  constructSwapWorkflowItemsErrorNotification,
)

export const addCopyVariogramDataNotification = compose(
  addNotification,
  constructCopyVarigramDataErrorNotification,
)

export const addDeleteErrorNotification = compose(
  addNotification,
  constructDeleteRelatedWorkflowItemErrorNotification,
)

export const addDeleteElementEventNotification = compose(
  addNotification,
  convertDeleteElementEventToNotification,
)

export const addPolygonNotification = compose(
  addNotification,
  convertPolygonUploadResultToNotification,
)

export const addMlStatusNotification = compose(addNotification, convertMlNotifyStatusToNotification)

export const addMlErrorNotification = compose(addNotification, convertMLErrorToNotification)

export const addVSPErrorNotification = compose(addNotification, convertVSPErrorToNotification)

export const addSurvey2dFileUploadErrorNotification = compose(
  addNotification,
  convertSurvey2dFileUploadErrorToNotification,
)

export const addVspAppliedNotification = compose(addNotification, constructVspAppliedNotification)

export const addProjectStateChangedNotification = compose(
  addNotification,
  constructProjectStateChangedNotification,
)

export const addSimpleNotification = compose(addNotification, constructSimpleNotification)

export const addPublishedElementNotification = compose(
  addNotification,
  convertPublishedElementToNotification,
)

export const addFileUploadErrorNotification = compose(
  addNotification,
  convertFileUploadErrorToNotification,
)

export const addPickerProgressNotification = compose(
  addNotification,
  convertPickerProgressToNotification,
)

export const addOrchCalculationErrorNotification = compose(
  addNotification,
  constructOrchCalculationErrorNotification,
)

export const addEmptyPointsetCalculationNotification = compose(
  addNotification,
  constructEmptyPointsetCalculationNotification,
)

export const addGltfLoadErrorNotification = compose(
  addNotification,
  convertEntityGltfLoadErrorToNotification,
)

export const addDeletedToTrashElementAddErrorNotification = compose(
  addNotification,
  constructDeletedToTrashElementAddErrorNotification,
)
